import React, { useEffect } from "react";

import FadeScroller from "components/fade-scroller";
import Heading from "components/heading";

import HeroSection from "../../../hero-section";
import SolarDesignsHeroSVG from "./hero-svg";

const title = "Create Accurate, CAD-Ready Solar Designs with Enerflo’s Solar Design Tool Integrations";

const MainHero = () => {
  useEffect(() => {
    // Scroll to center the highlighed hexagon
    const activeStepImagePath = document.getElementById("integrations-lead-to-pto-active-stage");
    if (activeStepImagePath) {
      activeStepImagePath.scrollIntoView({ block: "nearest", inline: "center" });
    }
  }, []);

  return (
    <HeroSection title={title}>
      <div className="w-full flex-grow space-y-6 md:space-y-10">
        <HeroSection.Content className="mx-auto md:text-center">
          <HeroSection.Header>
            <Heading tag="h1" size="h2">
              {title}
            </Heading>
          </HeroSection.Header>
          <HeroSection.Description>
            Choose your favorite solar design tool integration, or bring your own designers. Everything syncs through
            Enerflo.
          </HeroSection.Description>
        </HeroSection.Content>

        <div>
          <p className="font-semibold px-6 text-center md:hidden">Enerflo is your Lead-to-PTO Solar Platform</p>

          <FadeScroller>
            <figure className="min-w-[1200px] md:p-3 md:w-full">
              <SolarDesignsHeroSVG />
            </figure>
          </FadeScroller>
        </div>
      </div>
    </HeroSection>
  );
};

export default MainHero;
